module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-1.8a87b258.jpeg";